import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { api } from "../../lib/api";
import { Logo } from "../../components/site/Logo";
import { StonesAdmin } from "./StonesAdmin";
import { CategoriesAdmin } from "./CategoriesAdmin";
import { EnquiriesAdmin } from "./EnquiriesAdmin";
import { SiteImagesAdmin } from "./SiteImagesAdmin";
import { TextsAdmin } from "./TextsAdmin";

export default function Admin() {
  const nav = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    document.title = "Admin — THE STONE EDITION";
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => nav("/admin/login", { replace: true }));
  }, [nav]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("se_admin_token");
    nav("/admin/login");
  };

  if (!user) return <div className="min-h-screen flex items-center justify-center f-mono text-xs">…</div>;

  return (
    <div className="min-h-screen bg-[#FFFFFF]" data-testid="admin-page">
      <header className="border-b border-[#1A1A1A]/12 px-6 sm:px-10 py-5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-6"><Logo /><span className="eyebrow !text-[0.62rem] text-[#555555] hidden sm:inline">Gestione</span></div>
        <div className="flex items-center gap-6 text-sm">
          <Link to="/it" target="_blank" className="link-line hidden sm:inline" data-testid="admin-view-site">Vedi il sito</Link>
          <span className="text-[#555555] hidden md:inline">{user.email}</span>
          <button type="button" onClick={logout} className="eyebrow link-line" data-testid="admin-logout">Esci</button>
        </div>
      </header>
      <main className="px-6 sm:px-10 py-10">
        <Tabs defaultValue="stones">
          <TabsList className="bg-transparent p-0 h-auto gap-8 border-b border-[#1A1A1A]/12 w-full justify-start rounded-none overflow-x-auto overflow-y-hidden">
            {[["stones", "Lastre e blocchi"], ["site-images", "Immagini del sito"], ["texts", "Testi"], ["categories", "Categorie"], ["enquiries", "Richieste"]].map(([v, l]) => (
              <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`}
                className="shrink-0 rounded-none px-0 pb-3 bg-transparent shadow-none data-[state=active]:shadow-none data-[state=active]:bg-transparent border-b-2 border-transparent data-[state=active]:border-[#1A1A1A] f-serif text-xl font-light">{l}</TabsTrigger>
            ))}
          </TabsList>
          <TabsContent value="stones" className="mt-8"><StonesAdmin /></TabsContent>
          <TabsContent value="site-images" className="mt-8"><SiteImagesAdmin /></TabsContent>
          <TabsContent value="texts" className="mt-8"><TextsAdmin /></TabsContent>
          <TabsContent value="categories" className="mt-8"><CategoriesAdmin /></TabsContent>
          <TabsContent value="enquiries" className="mt-8"><EnquiriesAdmin /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
